import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export function CopyTeamsButton({ 
    teamsHeader, 
    triggerNotification, 
    children, 
    className = "btn btn-link p-0 text-decoration-none text-dark",
    style = { fontSize: '1.3rem' }
}) {
    const handleCopy = (e) => {
        e.stopPropagation();
        if (teamsHeader) {
            navigator.clipboard.writeText(teamsHeader);
            if (triggerNotification) {
                triggerNotification('Teams header copied to clipboard');
            }
        }
    };

    return (
        <OverlayTrigger
            delay={{ show: 1000 }}
            placement="top"
            overlay={<Tooltip id="copy-teams-tooltip">Copy Teams Header</Tooltip>}
        >
            <button
                onClick={handleCopy}
                className={className}
                style={style}
            >
                {children} 📋
            </button>
        </OverlayTrigger>
    );
}
